  export class HostModelRequest {
    constructor (
        public firstName?: string,
        public lastName?: string,
        public email?: string,
        public phone?: string,
        public companyId?: string,
        public venueIds?: Array<string>,
    ) {}
  }

  export class UpdateHostModelRequest {
    constructor (
        public hostId?: string,
        public firstName?: string,
        public lastName?: string,
        public email?: string,
        public phone?: string,
        public venueIds?: Array<string>,
    ) {}
  }
  export class GetHostsModelRequest {
    constructor (
        public VenueId: string,
        public CompanyId: string,
    ) {}
  }

  export class GetHostsModelResponse {
    constructor (
        public id?: string,
        public firstName?: string,
        public lastName?: string,
        public email?: string,
        public phone?: string,
        public venueIds?: Array<string>,
    ) {}
  }
    export class DeactivateHostModelRequest {
      constructor (
          public hostId?: string,
      ) {}
  }
  